import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import AutoplayVideo from '../../components/AutoplayVideo';
import './SatelliteSchools.css';

// Vertical (9:16) MP4 in public/videos (same video as the Head Teacher's message). Leave empty for a placeholder.
const VIDEO_URL = `${process.env.PUBLIC_URL}/videos/message-from-ht.mp4`;

// One school card (used for the online academy and for every location)
function SchoolCard({ school, featured }) {
  return (
    <div className={`schoolCard ${featured ? 'schoolCardFeatured' : ''}`}>
      <div className="schoolCardLogo">
        <img src={school.image} alt={school.name} />
      </div>
      <div className="schoolCardBody">
        {/* Only the academy shows its title; location names are part of the preview text */}
        {featured && (
          <h4 className="schoolCardTitle"><Trans ns="sateliteSchools" i18nKey={school.name} /></h4>
        )}
        <p className="schoolCardText"><Trans ns="sateliteSchools" i18nKey={`${school.name} preview`} /></p>
        <Link className="schoolCardButton" to={`/school/${school.name}`}>
          <Trans i18nKey="FindOutMoreAboutSchool" />
        </Link>
      </div>
    </div>
  );
}

function MainBlock() {
  const { t } = useTranslation('sateliteSchools');
  const schoolsList = useSelector((state) => state.satelliteSchools.schools_list);
  const academySchool = schoolsList.find((item) => item.name === 'academy');
  const locationSchools = schoolsList.filter((item) => item.name !== 'academy');

  return (
    <div className="schoolsPage">
      <div className="schoolsHero">
        <h2><Trans i18nKey="satellite schools" /></h2>
        <p><Trans i18nKey="satellite schools addition" /></p>
      </div>

      {/* Vertical video (left) + intro text (right); stacks on phones (see SatelliteSchools.css) */}
      <div className="schoolsIntroRow">
        <div className="schoolsVideoWrap">
          <AutoplayVideo src={VIDEO_URL} />
        </div>
        <p
          className="schoolsIntro"
          dangerouslySetInnerHTML={{ __html: t('academy overview intro') }}
        />
      </div>

      {academySchool && (
        <>
          <h3 className="schoolsSectionTitle"><Trans ns="sateliteSchools" i18nKey="academy online option" /></h3>
          <SchoolCard school={academySchool} featured />
        </>
      )}

      <h3 className="schoolsSectionTitle"><Trans ns="sateliteSchools" i18nKey="in-person study options" /></h3>
      <div className="schoolsGrid">
        {locationSchools.map((school) => (
          <SchoolCard key={school.name} school={school} />
        ))}
      </div>
    </div>
  );
}

export default MainBlock;
